// constants from https://github.com/pnorental/conti/blob/master/src/conti/consts.go 

const fittingPackages = {
    "FITTING": "Fitting",
    "REPAIR_MAJOR_WHEEL_CHANGE_FITTING": "Major Repair (including Wheel change and Fitting)",
    "REPAIR_MAJOR_WHEEL_CHANGE_FITTING_BALANCING": "Major Repair (including Wheel change, Fitting and Balancing)",
    "REPAIR_WHEEL_CHANGE_FITTING": "Repair (including Wheel change and Fitting)",
    "REPAIR_WHEEL_CHANGE_FITTING_BALANCING": "Repair (including Wheel change, Fitting and Balancing)",
    "SPARE_TIRE_CHANGE": "Spare tire change",
    "TURN_ON_THE_RIM": "Turn on the rim",
    "WHEEL_CHANGE": "Wheel change",
    "WHEEL_CHANGE_BALANCING": "Wheel change and Balancing",
    "WHEEL_CHANGE_FITTING": "Wheel change and Fitting",
    "WHEEL_CHANGE_FITTING_BALANCING": "Wheel change, Fitting and Balancing",
}

export const FittingPackages = { ...fittingPackages };

export const FittingPackage = function (pack) {
    return fittingPackages[pack] ? fittingPackages[pack] : null
}
